<template>
	<dv-border-box-12 class="lineBox" style="height:1.78rem;">
		<div class="box">
			<div class="box_title">创造</div>
			<div class="createList">
				<div class="createItem" v-for="(item,index) in createList" :key="index">
					<div class="createItem_num">
						<img src="@/assets/patent/huan.png" alt="">
						<span v-if="item.title == '万人拥有量'">{{item.total}}</span>
						<countTo v-else :startVal='0' :endVal='Number(item.total)'  :duration='800'></countTo>
					</div>
					<div class="title">{{item.title}}</div>
				</div>
			</div>
		</div>
	</dv-border-box-12>
</template>

<script>
	export default {
		data(){
			return{
				createList: [],
			}
		},
		methods:{
			getData(list){
				var that = this
				that.createList = []
				var arr = [
					{
						total:list.zl_fmgongk,
						title:'发明公开',
					},{
						total:list.zl_fmshouq,
						title:'发明授权',
					}, {
						total:list.zl_sxshouq,
						title: '新型授权',
					},{
						total:list.zl_wgshouq,
						title:'外观授权',
					},{
						total:list.zl_fmyoux,
						title: '发明有效',
					},{
						total:list.zl_wanr,
						title:'万人拥有量',
					},{
						total:list.zl_pctshenq,
						title:'PCT申请',
					},
				]
				// this.$forceUpdate();
				that.createList = arr
			},
		},
	}
</script>

<style>
</style>